import { useState } from 'react';
import { Plus } from 'lucide-react';
import { ApprovalChainsList } from '@components/Admin/ApprovalChains/ApprovalChainsList';
import { CreateChainWizard } from '@components/Admin/ApprovalChains/CreateChainWizard';
import { EditChainModal } from '@components/Admin/ApprovalChains/EditChainModal';
import PlanGate from '@components/common/PlanGate';
import UpgradeBanner from '@components/common/UpgradeBanner';

type ViewMode = 'list' | 'create' | 'edit';

export const ApprovalChainsPage = () => {
  const [viewMode, setViewMode] = useState<ViewMode>('list');
  const [selectedChainId, setSelectedChainId] = useState<string | null>(null);

  const handleCreateNew = () => {
    setSelectedChainId(null);
    setViewMode('create');
  };

  const handleEdit = (chainId: string) => {
    setSelectedChainId(chainId);
    setViewMode('edit');
  };

  const handleBack = () => {
    setViewMode('list');
    setSelectedChainId(null);
  };

  return (
    <PlanGate feature="approvals" fallback={<UpgradeBanner feature="approvals" />}>
    <div className="space-y-8">
      {/* Header */}
      <div className="flex items-start justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-50 mb-2">
            Approval Chains
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            Configure approval workflows and routing rules
          </p>
        </div>
        {viewMode === 'list' && (
          <button
            onClick={handleCreateNew}
            className="inline-flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
          >
            <Plus className="w-4 h-4" />
            New Chain
          </button>
        )}
      </div>

      {/* Content */}
      <div>
        {viewMode === 'list' && (
          <ApprovalChainsList
            onCreateNew={handleCreateNew}
            onEdit={handleEdit}
            simpleMode={true}
          />
        )}

        {viewMode === 'create' && (
          <CreateChainWizard
            onClose={handleBack}
            onSuccess={handleBack}
          />
        )}

        {viewMode === 'edit' && selectedChainId && (
          <EditChainModal
            chainId={selectedChainId}
            onClose={handleBack}
            onSuccess={handleBack}
            simpleMode={true}
          />
        )}
      </div>
    </div>
    </PlanGate>
  );
};
